import React, { useEffect, useState } from "react";
import FundsCard from "../../cards/FundsCard";
import { ClipLoader } from "react-spinners";
import BiddingLimit from "./funds/BiddingLimit.jsx";
import { useFunds } from "../../../context/FundsContext.js";
import { Modal } from "@mui/material";
import logo from "../../../assets/lux-logo/bidcaribbeansBlueLogo.jpg";
import useRefundRequest from "../../../hooks/invoice/useRefundRequest.js";
import { BsInfoCircle } from "react-icons/bs";
import { Tooltip as ReactTooltip } from "react-tooltip";
import WireTransferInvoice from "./WireTransferInvoice.jsx";
import BankDetails from "../BankDetails.js";
//
import { showToast } from "../../../utils/Toast.js";
import ReferenceGenerator from "../ReferenceGenerator.js";
import useWireTransfer from "../../../hooks/invoice/useWireTransfer.js";
import { useWireTransferContext } from "../../../context/WireTransferContext.js";

const Funds = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalRefund, setOpenModalRefund] = useState(false);
  const [openWireTransferModal, setOpenWireTransferModal] = useState(false);
  const [openWireTransferInvoiceModal, setOpenWireTransferInvoiceModal] =
    useState(false);

  const { fundsData, loading, error, fetchFunds } = useFunds();
  const {
    success,
    loading: refundLoading,
    error: refundError,
    refundRequest,
    resetRefundState,
  } = useRefundRequest();
  const [refundMethod, setRefundMethod] = useState(null); // 'card' | 'wire' | null
  const [bankForm, setBankForm] = useState({
    bankName: "",
    accountNumber: "",
    branchNumber: "",
    transitNumber: "",
  });
  const [bankErrors, setBankErrors] = useState({});
  const [generatedRef, setGeneratedRef] = useState(null);
  const { submitWirePayment } = useWireTransfer();
  const {refreshWireTransfers} = useWireTransferContext();
  

  useEffect(() => {
    fetchFunds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const totalFunds = fundsData?.data?.totalDeposits || 0;

  useEffect(() => {
    if (!openModalRefund) {
      setRefundMethod(null);
      setBankForm({ bankName: "", accountNumber: "", branchNumber: "", transitNumber: "" });
      setBankErrors({});
    }
  }, [openModalRefund]);

  const validateBankForm = () => {
    const errors = {};
    if (!bankForm.bankName?.trim()) errors.bankName = "Bank name is required";
    if (!bankForm.accountNumber?.trim()) errors.accountNumber = "Account number is required";
    if (!bankForm.branchNumber?.trim()) {
      errors.branchNumber = "Branch number is required";
    } else if (!/^\d+$/.test(bankForm.branchNumber)) {
      errors.branchNumber = "Branch number must be numeric";
    }
    if (!bankForm.transitNumber?.trim()) {
      errors.transitNumber = "Transit number is required";
    } else if (!/^\d+$/.test(bankForm.transitNumber)) {
      errors.transitNumber = "Transit number must be numeric";
    }
    setBankErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCardRefund = async () => {
    try {
      await refundRequest({ refundMethod: "card" });
      fetchFunds();
    } catch (_) {}
  };

  const handleWireRefund = async () => {
    if (!validateBankForm()) return;
    try {
      await refundRequest({
        refundMethod: "wire",
        bankName: bankForm.bankName,
        accountNumber: bankForm.accountNumber,
        branchNumber: bankForm.branchNumber,
        transitNumber: bankForm.transitNumber,
      });
      fetchFunds();
    } catch (_) {}
  };

  return (
    <>
      <div className="w-[90vw] lg:w-[85vw] mx-auto mt-6 lg:mt-[1.5vw]  text-black ">
        <div className="flex text-left item-center justify-between">
          <p className="text-[24px] md:text-[36px] lg:text-[2.3vw] text-left lg:text-left font-urbanist font-bold">
            My Funds
          </p>
          <div className="flex justify-end lg:justify-center gap-x-1 md:gap-x-2 lg:gap-3 relative">
            <button
              className={`w-[90px] md:w-[110px] lg:w-[11vw] h-[36px] lg:h-[6vh] flex justify-center font-semibold rounded-lg items-center ${totalFunds <= 0 ? "bg-gray-500 hover:bg-gray-500/90 cursor-not-allowed" : "bg-primary-red hover:bg-primary-red/90"}  text-white text-[13px] lg:text-[1vw] font-urbanist`}
              onClick={() => setOpenModalRefund(true)}
              disabled={totalFunds <= 0}
            >
              Refund
            </button>
            <button
              onClick={() => setOpenModal(true)}
              className="w-[90px] md:w-[110px] lg:w-[11vw] h-[36px] lg:h-[6vh] flex justify-center font-semibold rounded-lg items-center bg-primary-red hover:bg-primary-red/90 text-white text-[13px] lg:text-[1vw] font-urbanist"
            >
              Online Deposit
            </button>
            <button
              onClick={() => setOpenWireTransferModal(true)}
              className="w-[90px] md:w-[110px] lg:w-[11vw] h-[36px] lg:h-[6vh] flex justify-center font-semibold rounded-lg items-center bg-primary-red hover:bg-primary-red/90 text-white text-[13px] lg:text-[1vw] font-urbanist"
            >
              Wire Transfer
            </button>
          </div>
        </div>
        {/* Loading State */}
        {loading && (
          <div className="flex justify-center items-center min-h-[30vh]">
            <ClipLoader size={50} color={"#D0021B"} loading={loading} />
            <p className="ml-3 text-[18px] lg:text-[1.2vw] font-urbanist text-gray-500">
              Loading your funds...
            </p>
          </div>
        )}

        {/* Error State */}
        {error && (
          <>
            <FundsCard className="font-semibold" />

            {/* <div className="flex justify-center items-center   flex-col min-h-[30vh]">
              <div className="flex flex-col items-center justify-center min-h-[50vh]">
                <p className="text-2xl font-bold text-gray-500">{error}</p>
                <p className="text-gray-400 mt-2">Please try again later</p>
                <button
                  className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg"
                  onClick={() => setOpenModal(true)}
                >
                  Deposit Funds
                </button>
              </div>
            </div> */}
          </>
        )}

        {/* Funds Data */}
        {!loading && !error && fundsData.data && (
          <FundsCard fund={fundsData.data} className="font-semibold" />
        )}
      </div>

      <BiddingLimit
        openModalProp={openModal}
        setOpenModalProp={setOpenModal}
        fetchFunds={fetchFunds}
      />

      <Modal open={openModalRefund} onClose={() => { setOpenModalRefund(false); resetRefundState(); }}>
        <div className="bg-white p-6 lg:m-0 m-1 rounded-lg shadow-lg w-full lg:w-[800px] max-h-[90vh] overflow-y-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="bg-[#008b98] rounded-lg w-full">
            <img
              src={logo}
              alt="Company Logo"
              className="w-[25%] h-auto mx-auto"
            />
          </div>

          <div className="text-center py-4">
            {!success ? (
              <>
                <div className="flex justify-center items-center gap-x-2">
                  <h1 className="text-xl font-bold">BidCaribbean Refund Request</h1>
                  <BsInfoCircle
                    data-tooltip-id="refund-info"
                    className="font-extrabold text-[20px] sm:text-24 animate-pulse cursor-pointer"
                  />
                </div>

                {!refundMethod && (
                  <>
                    <p className="text-gray-600 text-left mt-5 ml-2">
                      <strong>Did you pay by Card or Wire Transfer?</strong>
                    </p>
                    {refundError && (
                      <p className="text-red-600 border bg-red-50 border-red-600 p-2 my-2 rounded-md">
                        {refundError}
                      </p>
                    )}
                    <div className="flex flex-col sm:flex-row justify-center gap-3 mt-4">
                      <button
                        onClick={() => setRefundMethod("card")}
                        className="px-4 py-2 bg-primary-red text-white rounded-lg hover:bg-primary-red/90 transition"
                      >
                        Card
                      </button>
                      <button
                        onClick={() => setRefundMethod("wire")}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                      >
                        Wire Transfer
                      </button>
                      <button
                        onClick={() => { setOpenModalRefund(false); resetRefundState(); }}
                        className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition"
                      >
                        Cancel
                      </button>
                    </div>
                    <p className="text-gray-600 text-left mt-4">
                      Once submitted, our team will process your request within
                      <strong> 48 business hours.</strong> You’ll receive a confirmation email once the refund is initiated.
                    </p>
                  </>
                )}

                {refundMethod === "card" && (
                  <div className="text-left">
                    <p className="text-gray-700 mt-5 ml-2">
                      <strong>Note:</strong> A <strong>3.5%</strong> processing fee will be applied. Refund may take up to <strong>48 hours</strong>.
                    </p>
                    {refundError && (
                      <p className="text-red-600 border bg-red-50 border-red-600 p-2 my-2 rounded-md">
                        {refundError}
                      </p>
                    )}
                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        onClick={() => setRefundMethod(null)}
                        className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition"
                        disabled={refundLoading}
                      >
                        Back
                      </button>
                      <button
                        onClick={handleCardRefund}
                        disabled={refundLoading}
                        className="px-4 py-2 bg-primary-red text-white rounded-lg hover:bg-primary-red/90 transition flex items-center"
                      >
                        {refundLoading ? <ClipLoader size={20} color="#fff" /> : "Proceed with Refund"}
                      </button>
                    </div>
                  </div>
                )}

                {refundMethod === "wire" && (
                  <div className="text-left">
                    <p className="text-gray-700 mb-4 mt-3">
                      Please provide your bank details so we can process your wire transfer refund.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Bank Name</label>
                        <input
                          type="text"
                          value={bankForm.bankName}
                          onChange={(e) => setBankForm({ ...bankForm, bankName: e.target.value })}
                          className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${bankErrors.bankName ? 'border-red-500' : 'border-gray-300'}`}
                          placeholder="Enter bank name"
                          disabled={refundLoading}
                        />
                        {bankErrors.bankName && <p className="text-xs text-red-600 mt-1">{bankErrors.bankName}</p>}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Account Number</label>
                        <input
                          type="text"
                          value={bankForm.accountNumber}
                          onChange={(e) => setBankForm({ ...bankForm, accountNumber: e.target.value })}
                          className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${bankErrors.accountNumber ? 'border-red-500' : 'border-gray-300'}`}
                          placeholder="Enter account number"
                          disabled={refundLoading}
                        />
                        {bankErrors.accountNumber && <p className="text-xs text-red-600 mt-1">{bankErrors.accountNumber}</p>}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Branch Number</label>
                        <input
                          type="text"
                          value={bankForm.branchNumber}
                          onChange={(e) => setBankForm({ ...bankForm, branchNumber: e.target.value })}
                          className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${bankErrors.branchNumber ? 'border-red-500' : 'border-gray-300'}`}
                          placeholder="Enter branch number"
                          disabled={refundLoading}
                        />
                        {bankErrors.branchNumber && <p className="text-xs text-red-600 mt-1">{bankErrors.branchNumber}</p>}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Transit Number</label>
                        <input
                          type="text"
                          value={bankForm.transitNumber}
                          onChange={(e) => setBankForm({ ...bankForm, transitNumber: e.target.value })}
                          className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${bankErrors.transitNumber ? 'border-red-500' : 'border-gray-300'}`}
                          placeholder="Enter transit number"
                          disabled={refundLoading}
                        />
                        {bankErrors.transitNumber && <p className="text-xs text-red-600 mt-1">{bankErrors.transitNumber}</p>}
                      </div>
                    </div>

                    {refundError && (
                      <p className="text-red-600 border bg-red-50 border-red-600 p-2 my-2 rounded-md">
                        {refundError}
                      </p>
                    )}

                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        onClick={() => setRefundMethod(null)}
                        className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition"
                        disabled={refundLoading}
                      >
                        Back
                      </button>
                      <button
                        onClick={handleWireRefund}
                        disabled={refundLoading}
                        className="px-4 py-2 bg-primary-red text-white rounded-lg hover:bg-primary-red/90 transition flex items-center"
                      >
                        {refundLoading ? <ClipLoader size={20} color="#fff" /> : "Submit Refund Request"}
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center">
                <h2 className="text-xl font-bold text-green-600">Thank you!</h2>
                <p className="text-gray-600">
                  Your refund request has been submitted successfully. Our team
                  will process it soon.
                </p>
                <button
                  onClick={() => { setOpenModalRefund(false); resetRefundState(); }}
                  className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </Modal>
      <ReactTooltip
        float={true}
        className="lg:text-16 z-50"
        id="refund-info"
        content={
          <div class="max-w-md lg:max-w-lg" style={{ zIndex: 9999 }}>
            <div class="mb-3">
              <p class="font-semibold mb-2">About Our Refund Process:</p>
              <ul class="list-disc pl-4 space-y-1 text-left">
                <li>
                  Once submitted, our team will process your request within{" "}
                  <strong>48 business hours.</strong>
                </li>
                <li>
                  You'll receive a confirmation email once the refund is
                  initiated.
                </li>
              </ul>
            </div>

            <div>
              <p class="font-semibold mb-2">Important Notes:</p>
              <ul class="list-disc pl-4 space-y-1 text-left">
                <li>Refunds are subject to our terms and conditions.</li>
                <li>
                  If the original payment was made using a credit or debit card,
                  please note that card processing fees charged by payment
                  providers are non-refundable.
                </li>
                <li>
                  For any questions or concerns, contact our support team at
                  customersupport@bidcaribbean.co
                </li>
                <li>
                  We value your trust and are committed to ensuring a smooth
                  experience on our platform.
                </li>
              </ul>
            </div>
          </div>
        }
        style={{ maxWidth: "400px", fontWeight: 400, zIndex: 9999 }}
      />

      <Modal
        open={openWireTransferModal}
        onClose={() => setOpenWireTransferModal(false)}
      >
        <div className="bg-white p-6 lg:m-0 m-2 rounded-2xl shadow-2xl w-full lg:w-[700px] max-h-[90vh] overflow-y-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="bg-[#008b98] p-4 rounded-xl flex justify-center">
            <img src={logo} alt="Company Logo" className="w-28 h-auto" />
          </div>

          <div className="text-center py-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Bank Account Details
            </h1>
            <p className="text-gray-600 text-sm mb-6">
              Banking Credentials for wire transfer
            </p>

            <BankDetails />

            {/* Bidding Limit Info Box */}
            <div className="bg-blue-50 border border-blue-200 text-center rounded-lg px-6 py-5 mt-6">
              <h2 className="text-lg font-bold text-blue-800 mb-2">
                Want to start bidding?
              </h2>
              <p className="text-sm text-gray-700">
                Make a minimum deposit of{" "}
                <span className="font-semibold text-blue-800">$350</span> to
                activate your bidding limit and start bidding on local vehicles.
                To bid on imported vehicles, increase your deposit to at least{" "}
                <span className="font-semibold text-blue-800">$750</span>.
              </p>

              <p className="text-sm text-gray-700 mt-4">
                <span className="font-semibold">
                  Before uploading your proof of payment
                </span>
                , please generate a{" "}
                <span className="font-semibold text-blue-800">
                  Reference ID
                </span>
                . Include this ID in the description or reference field when
                uploading your payment proof — this helps us accurately match
                your deposit to your account.
              </p>

              <p className="text-xs text-gray-600 mt-4">
                💡 To learn more about how your deposit affects your bidding
                power, please scroll to the bottom of this page.
              </p>
            </div>
            <ReferenceGenerator onReferenceGenerated={setGeneratedRef} />

            <div className="flex justify-center gap-x-4 mt-10">
              <button
                onClick={() => setOpenWireTransferModal(false)}
                className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
              >
                Close
              </button>

              {generatedRef && (
                <button
                  onClick={() => {
                    if (!generatedRef) {
                      showToast("Reference ID is missing", "error");
                      return;
                    }

                    submitWirePayment({
                      referenceId: generatedRef,
                    })
                      .then(() => {
                        localStorage.removeItem("ref_generated_once");
                        setOpenWireTransferModal(false);
                        refreshWireTransfers();
                    
                      })
                      .catch((err) => {
                        // console.error("Error:", err);
                        showToast(
                          err.response?.data?.message ||
                            err.message ||
                            "Failed to submit wire transfer",
                          "error"
                        );
                      });
                  }}
                  className="px-5 py-2 bg-primary-red text-white rounded hover:bg-primary-red/90 transition"
                >
                  Save Ref ID
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <WireTransferInvoice
        isOpen={openWireTransferInvoiceModal}
        onClose={() => setOpenWireTransferInvoiceModal(false)}
        fetchFunds={fetchFunds}
      />
    </>
  );
};

export default Funds;
